import { useContext } from 'react';

import { ApartmentsFilterContext } from 'context/apartmentsFilterContext';
import { TranslationContext } from 'context/translationContext';
import intParser from 'utils/intParser';
import { ROOMS_COLORS_DESCRIPTION } from 'utils/legend';

import styles from './styles.module.scss';
import { Props } from './types';

const Legend = ({ maxRooms }: Props) => {
  const { filterValues, setFilterValue } = useContext(ApartmentsFilterContext);
  const { t } = useContext(TranslationContext);

  const totalNumberOfRooms = Math.min(maxRooms, 5);
  const roomIcons = ROOMS_COLORS_DESCRIPTION(t).slice(0, totalNumberOfRooms);

  const { roomMin, roomMax } = filterValues;
  const roomMinNumber = intParser(roomMin);
  const roomMaxNumber = intParser(roomMax);

  const isSelected = (id: string) => {
    const selectedId = intParser(id);
    return selectedId >= roomMinNumber && selectedId <= roomMaxNumber;
  };

  const handleSetRoomFilter = (id: string) => {
    if (isSelected(id)) {
      setFilterValue('roomMin', '');
      setFilterValue('roomMax', '');
    } else {
      setFilterValue('roomMin', id);
      setFilterValue('roomMax', id);
    }
  };

  return (
    <div className={styles.container}>
      <span className={styles.label}>{t('legend')}</span>
      {roomIcons.map(desc => (
        <div
          key={desc.color}
          className={styles.colorWrapper}
          onClick={() => handleSetRoomFilter(desc.id)}
        >
          <div
            className={[
              styles.colorDesc,
              isSelected(desc.id) && styles.colorDescSelected,
            ].join(' ')}
            style={{ backgroundColor: desc.color }}
          ></div>
          <span
            className={[
              styles.colorLabel,
              isSelected(desc.id) && styles.colorLabelSelected,
            ].join(' ')}
          >
            {desc.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Legend;
